<template>
  <!--<div>-->
    <!--code:{{code}}<br />-->
    <!--response:{{response}}<br />-->
    <!--response_user:{{response_user}}-->
  <!--</div>-->
</template>

<script>
export default {
    name: "three-login-code",
  components:{
  },
  data() {
      return{
       code:'',
        response:{},
        response_user:{},
     }
  },
  created(){
    // const code = getUrlParam('code');//获取url 上面的code
    // var state=getUrlParam('state'); //获取state，用于页面跳转
    var code=this.$route.query.code
    this.code=code;
    // this.getToken('51152ba7-1c29-426d-9000-11e1b70a8818');
    this.getToken(code);
  },
  methods:{
      getToken(code){
        var loading = this.$loading({
          lock: true,
          text: '数据处理中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        //根据code获取token
        const option={
          code:code,
        }

        var tt=this;
        this.$https.get("api/pu/threeUserLogin.do",option,response=>{
          loading.close();
          if (response.status === 200 && response.data.code===200) {
            tt.$cookies.set("userId",response.data.data.userId,"3D")
            tt.$cookies.set("token",response.data.data.token,"3D")
            tt.$cookies.set("userInfo",response.data.data,"3D")

            tt.$cookies.set("isLegal",response.data.data.isLegal,"3D")
            tt.$cookies.set("companyName",response.data.data.companyName,"3D")

            tt.$cookies.set("threeTokenId",response.data.data.threeTokenId,"3D")
                tt.$https.post("api/pu/getPuUserAreaWeb.do",{userId:response.data.data.userId},responses=>{
                  if (responses.status === 200 && responses.data.code===200 && responses.data.data !=null) {
                    tt.$cookies.set("areaInfo",responses.data.data,"3D")
                    // tt.initAreaInfo();
                  }
                  tt.$router.push({path:'home',query:{}});
                })
                // if(tt.reloadPage){
                // }
          } else {
            tt.$router.push({path:'home',query:{}});
            tt.$alert(response.data.msg, "提示", {
              confirmButtonText: '确定'});

          }
        })
      },
  }
}

// 解析url参数并获取code
function getUrlParam(name) {   //name为要获取的参数名
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var rrr = decodeURIComponent(window.location.search);
  var r = rrr.substr(1).match(reg);
  if(r != null) return unescape(r[2]);
  return null;
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ThreeLoginCode.vue